import React, { Component } from "react";
import PropTypes from "prop-types";
import { Alert } from "reactstrap";
import { withRouter } from "react-router-dom";
import Api from "../services/globalBibleApi";
import SiteForm from "../components/SiteForm";
import BreadCrumbs from "../components/BreadCrumbs";

class SiteEdit extends Component {
  constructor() {
    super();
    this.state = {
      site: null,
      notifications: []
    };
  }

  componentDidMount() {
    Api.getSite(this.props.match.params.siteId)
      .then(site => this.setState({ site }))
      .catch(console.error); // eslint-disable-line
  }

  handleSubmit(site) {
    Api.updateSite(site)
      .then(res => {
        this.setState({
          notifications: [{ type: "success", message: res.message }]
        });
      })
      .catch(err => {
        const message = err.response
          ? err.response.data.message
          : "Error saving site";
        this.setState({
          notifications: [{ type: "error", message }]
        });
      });
  }

  render() {
    const { notifications, site } = this.state;
    const { location } = this.props;

    return (
      <div>
        <BreadCrumbs
          title={`Edit Site${site ? `: ${site.title}` : ""}`}
          paths={[
            { title: "Sites", link: "/sites" },
            { title: "Edit Site", link: location.pathname }
          ]}
        />
        {site && (
          <>
            {notifications.map(({ message, type }) => (
              <Alert
                key={message}
                color={type === "error" ? "danger" : undefined}
              >
                {message}
              </Alert>
            ))}
            <SiteForm
              site={site}
              onSubmit={siteData => this.handleSubmit(siteData)}
            />
          </>
        )}
      </div>
    );
  }
}

SiteEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      siteId: PropTypes.string
    })
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
};

export default withRouter(SiteEdit);
